// tslint:disable:max-line-length
import { createInitialDecimalFieldConditions } from './filter-decimal/create-initial-decimal-field-conditions';
import { selectMultipleHierarchyConditionMapper, selectMultipleHierarchyConfiguration, selectMultipleHierarchySequentialWithCategoriesConfiguration, selectMultipleHierarchyWithCategoriesConfiguration } from './filter-code-hierarchy/select-multiple-hierarchy';
import { createInitialDefaultValue } from './create-initial-default-value';
import { checkboxConfiguration, checkboxConditionMapper } from './filter-checkbox/checkbox';
import { createInitialDateFieldConditions } from './filter-date-range/create-initial-date-field-conditions';
import { dateFieldConditionMapper, dateFieldConfiguration, dateFieldOptionType } from './filter-date-range/date-field';
import { decimalNumberConfiguration, decimalNumberConditionMapper, decimalNumberOptionType } from './filter-decimal/decimal-number';
import { selectMultipleConfiguration, selectMultipleConditionMapper } from './filter-code/select-multiple';
import { myLocationConfiguration } from './filter-domain/my-location';
import { myPersonConfiguration, myPersonConditionMapper } from './filter-domain/my-person';
import { myUnitConfiguration, myUnitConditionMapper } from './filter-domain/my-unit';
import { numberFieldConfiguration, numberFieldConditionMapper, numberFieldOptionType } from './filter-number/number-field';
import { createInitialNumberFieldConditions } from './filter-number/create-initial-number-field-conditions';
import { predefinedDateConfiguration } from './filter-predefined-date/predefined-date';
import { predefinedFiltersConfiguration } from './filter-predefined-filters/predefined-filters';
import { textFieldConfiguration, textFieldConditionMapper, textFieldOptionType } from './filter-text/text-field';
import { createInitialTextFieldConditions } from './filter-text/create-initial-text-field-conditions';
import { myLocationConditionMapper } from './filter-domain/my-location';
import { createInitialMyLocationConditions } from './filter-domain/create-initial-my-location-conditions';
import { createInitialPersonConditions } from './filter-domain/create-initial-person-conditions';
import { createInitialMyUnitConditions } from './filter-domain/create-initial-my-unit-conditions';
import { selectMultipleFlatConfiguration, selectMultipleFlatConditionMapper, selectMultipleFlatWithCategoriesConfiguration, selectMultipleFlatSequentialWithCategoriesConfiguration } from './filter-code/select-multiple-flat';

export const configuration = [
  {
    configuration: checkboxConfiguration,
    mapper: checkboxConditionMapper,
    initialValue: undefined
  },
  {
    configuration: selectMultipleConfiguration,
    mapper: selectMultipleConditionMapper,
    initialValue: undefined
  },
  {
    configuration: selectMultipleFlatConfiguration,
    mapper: selectMultipleFlatConditionMapper,
    initialValue: undefined
  },
  {
    configuration: selectMultipleHierarchyConfiguration,
    mapper: selectMultipleHierarchyConditionMapper,
    initialValue: createInitialDefaultValue
  },
  {
    configuration: selectMultipleFlatWithCategoriesConfiguration,
    mapper: selectMultipleFlatConditionMapper,
    initialValue: undefined
  },
  {
    configuration: selectMultipleHierarchyWithCategoriesConfiguration,
    mapper: selectMultipleHierarchyConditionMapper,
    initialValue: createInitialDefaultValue
  },
  {
    configuration: selectMultipleFlatSequentialWithCategoriesConfiguration,
    mapper: selectMultipleFlatConditionMapper,
    initialValue: createInitialDefaultValue
  },
  {
    configuration: selectMultipleHierarchySequentialWithCategoriesConfiguration,
    mapper: selectMultipleHierarchyConditionMapper,
    initialValue: createInitialDefaultValue
  },
  {
    configuration: dateFieldConfiguration,
    mapper: dateFieldConditionMapper,
    initialValue: createInitialDateFieldConditions,
    optionType: dateFieldOptionType
  },
  {
    configuration: decimalNumberConfiguration,
    mapper: decimalNumberConditionMapper,
    initialValue: createInitialDecimalFieldConditions,
    optionType: decimalNumberOptionType
  },
  {
    configuration: myLocationConfiguration,
    mapper: myLocationConditionMapper,
    initialValue: createInitialMyLocationConditions
  },
  {
    configuration: myPersonConfiguration,
    mapper: myPersonConditionMapper,
    initialValue: createInitialPersonConditions
  },
  {
    configuration: myUnitConfiguration,
    mapper: myUnitConditionMapper,
    initialValue: createInitialMyUnitConditions
  },
  {
    configuration: numberFieldConfiguration,
    mapper: numberFieldConditionMapper,
    initialValue: createInitialNumberFieldConditions,
    optionType: numberFieldOptionType
  },
  {
    configuration: predefinedDateConfiguration,
    mapper: undefined,
    initialValue: undefined
  },
  {
    configuration: predefinedFiltersConfiguration,
    mapper: undefined,
    initialValue: undefined
  },
  {
    configuration: textFieldConfiguration,
    mapper: textFieldConditionMapper,
    initialValue: createInitialTextFieldConditions,
    optionType: textFieldOptionType
  }
];
